import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./UserCreatePassword.css"
import { useState } from 'react';
import Swal from "sweetalert2";



const UserCreatePassword = ({ show, requestClose, currentUserID, currentUserName }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //INPUTS CONTROLS
    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);

    const setupPassword = async () => {

        //MAIN VALIDATION
        if(!password || !confirmPassword){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        if(password !== confirmPassword){

            //Show message sweet alert
            Swal.fire({
                title: "No Coinciden",
                text: "El password ingresado y la confirmación no coinciden.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//


        //
        const metadata = {
            "id": currentUserID,
            "passowrd": password.replace(/[\t\\']/g, '').trim(),
        };

        console.log(metadata);
        
        let endpoint = "setPasswordUser?userID=" + currentUserID + "&plainPassword=" + password;

        //API SHOT
        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
        });


        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });

        //CLOSE MODAL
        requestClose(false);

    } //
    

    return (
        <div style={{paddingRight:"40px"}}>
        <Modal show={show} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Creación de Password de Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                
                <span style={{fontSize: "13px", color:"darkred"}}>Su usuario no tiene password asignado. <br />A continuación debe definir un password para usar la plataforma.</span>
                <hr />

                <Row>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Username</Form.Label>
                             <Form.Control 
                             type="text" 
                             value={currentUserName}
                             disabled="disabled"
                             placeholder="Username (login)"/><br />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Contraseña</Form.Label>
                             <Form.Control 
                             type="password" 
                             onChange={(event)=> setPassword(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Confirmación de Contraseña</Form.Label>
                             <Form.Control 
                             type="password" 
                             onChange={(event)=> setConfirmPassword(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={setupPassword}
                >
                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>

        </div>
    );
}

export default UserCreatePassword;